import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";
import { auth, db, functions } from "firebaseApp";
import { addDoc, collection } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import ModelSelectorMenu from "../ModelSelectorMenu";
import { imageStudioActions } from "store/imageStudio";

export default function PromptModal({ open, setOpen, setImage }) {
  const uid = auth.currentUser?.uid;

  const theme = useTheme();
  const dispatch = useDispatch();
  const [prompt, setPrompt] =
    useState(`A bird flying above "Ilha do pesseguerio" in Portugal on a stormy 
day in the style of the art from the Torment block.`);
  const [generating, setGenerating] = useState(false);

  const model = useSelector(
    (state) => state.imageStudio.mtgTokenSettings.model
  );

  const handleGenerate = async () => {
    try {
      setGenerating(true);
      const finalPrompt = `
        Generate the art for a magic the gathering token.
        Generate the art only, no border.
        Here's the user prompt for the art:
        ${prompt}
      `;
      const payload = {
        uid,
        prompt: finalPrompt,
        images: [],
        ratio: "square",
        transparent: false,
        generating: true,
        createdAt: new Date().getTime(),
        metadata: {
          isMtgTokenArt: true,
        },
        modelName: model.name,
      };
      await addDoc(collection(db, "imageGeneration"), payload);

      // if (data.data && data.data.length > 0) {
      //   const b64 = data.data[0].b64_json;

      //   // Convert base64 to object URL
      //   const img = new Image();
      //   img.src = "data:image/png;base64," + b64;

      //   img.onload = () => {
      //     setImage(img); // now you can draw this on the canvas
      //     setOpen(false);
      //   };

      //   img.onerror = (err) => {
      //     console.error("Failed to load image", err);
      //     toast.error("Failed to load image");
      //   };
      // }
      toast.success("Image generation started!");
      setOpen(false);
    } catch (error) {
      console.log(error);
      toast.error("An error occurred");
    } finally {
      setGenerating(false);
    }
  };

  useEffect(() => {
    //setPrompt("");
    //setGenerating(false);
  }, [open]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <DialogTitle>Generate With AI</DialogTitle>
      <DialogContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography
            sx={{
              color: theme .palette.text.main,
            }}
          >
            Model
          </Typography>

          <ModelSelectorMenu
            model={model}
            setModel={(model) =>
              dispatch(
                imageStudioActions.updateTokenSettings({
                  field: "model",
                  value: model,
                })
              )
            }
          />
        </Stack>
        <Stack pt={1} spacing={2}>
          <Typography variant="caption">
            The AI is aware that this image is to be used as the art of a MTG
            card. You should only specify what you want the drawing to be.
          </Typography>
          <TextField
            multiline
            maxRows={4}
            label="Prompt"
            value={prompt}
            onChange={(event) => setPrompt(event.target.value)}
            disabled={generating}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          variant="contained"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button
          variant="contained"
          disabled={generating || !prompt}
          onClick={handleGenerate}
        >
          {generating ? <CircularProgress size={24} /> : "Generate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
